import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tabela-relatorio',
  templateUrl: './tabela-relatorio.component.html',
  styleUrls: ['./tabela-relatorio.component.scss']
})
export class TabelaRelatorioComponent {
  @Input() apareceOuNao?: boolean = true;
  @Input() equipamento?: string;
  @Input() cabecalhosTabela: string[];
  @Input() informacoesTabela: any[];
}
